import React, {FC} from 'react';
import {useIntl} from 'react-intl';

import {MountableModal} from '@components/molecules';
import {Button, BUTTON_VARIANT, SPACE} from '@lookiero/aurora';
import {useReferralLink} from '@raf/ui/hooks/useReferralLink';
import {Section} from '@views/Referrals';
import {Platform} from 'react-native';

export interface ShareModalProps {
  isVisible: boolean;
  onClose: () => void;
  referralCode?: string;
  referredCredit: number;
  section: Section;
}

export const ShareModal: FC<ShareModalProps> = ({isVisible, onClose, referralCode = '', referredCredit, section}) => {
  const {formatMessage} = useIntl();
  const {shareReferral} = useReferralLink({referralCode, referredCredit});

  return (
    <MountableModal
      isVisible={isVisible}
      portalID={'raf-share-modal'}
      title={formatMessage({id: 'raf.sharemodal.title'})}
      onClose={onClose}
    >
      <Button
        variant={BUTTON_VARIANT.SECONDARY}
        icon={'social_whatsapp'}
        onPress={() => shareReferral('whatsapp', section)}
        testID={'share-button-whatsapp'}
      >
        {formatMessage({id: 'raf.sharemodal.whats'})}
      </Button>

      {Platform.OS === 'web' && (
        <Button
          variant={BUTTON_VARIANT.SECONDARY}
          icon={'social_facebook'}
          marginTop={SPACE.SPACE_4}
          onPress={() => shareReferral('facebook', section)}
          testID={'share-button-facebook'}
        >
          {formatMessage({id: 'raf.sharemodal.fb'})}
        </Button>
      )}
      <Button
        marginTop={SPACE.SPACE_4}
        variant={BUTTON_VARIANT.SECONDARY}
        icon={'inbox'}
        onPress={() => shareReferral('email', section)}
        testID={'share-button-email'}
      >
        {formatMessage({id: 'raf.sharemodal.email'})}
      </Button>
    </MountableModal>
  );
};
